import { render } from "./Chat_Composer.vue?vue&type=template&id=5fb6a64b"
import script from "./Chat_Composer.vue?vue&type=script&lang=js"
export * from "./Chat_Composer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__